import { useState } from "react";
import Footer from "../comman/Footer";
import Header from "../comman/Header-copy";
import CustomLoader from "../comman/Loader/CustomLoader";
import Topbar from "../comman/Topbar";
import UserGeneralInfo from "../comman/UserGeneralInfo";
import UserWalletInfo from "../comman/UserWalletInfo";

const Profile = () => {
    const[isLoading , setIsLoading] = useState(false);

    return (
            <>
             <div className="min-h-[100vh]">
            <Header />
            <Topbar />
            <CustomLoader visible={isLoading} />
            <div className="profile-wrapper ">
                <UserGeneralInfo/>
                <UserWalletInfo />
            </div>
            </div>

            <Footer colorClass="footerColor" clas="footer2" />
            </>
        )
}

export default Profile;